/** @jsx jsx */
import { jsx } from "theme-ui"
import { Component } from "react"
import PropTypes from "prop-types"

import NavigationSubmenu from "./navigation-submenu"
import Icon from "../assets/icon"
import Link from "./link"
import { ab, colors, navigationSubmenuDesktopWidth } from "../theme"

class NavigationSubItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: props.currentPage,
      defaultOpen: props.open ? true : false,
      parentOpen: props.parentOpen,
      currentPage: props.currentPage,
      seoLinks: props.seoLinks,
    }
    this.handleClick = this.handleClick.bind(this)
    this.toggleOpen = this.toggleOpen.bind(this)
    this.closeFn = this.closeFn.bind(this)
  }

  static getDerivedStateFromProps(props, state) {
    return {
      parentOpen: props.parentOpen,
      open: props.parentOpen
        ? props.parentOpen === state.parentOpen
          ? state.open
          : state.defaultOpen
        : false,
    }
  }

  handleClick() {
    this.toggleOpen()
  }

  toggleOpen() {
    this.setState({
      open: !this.state.open,
    })
  }

  closeFn() {
    this.setState({ open: false })
    this.props.closeFn()
  }

  render() {
    if (this.props.navigationItems && this.props.navigationItems.length > 0) {
      return (
        <div
          sx={{
            color: colors.navigationText,
            textAlign: "left",
            fontSize: 2,
            padding: 20,
            cursor: "pointer",
            "& > .submenu": {
              height: "100%",
              animationName: this.state.open ? "slideIn" : "slideOut",
              animationDuration: "400ms",
              animationFillMode: "forwards",
              "@keyframes slideIn": {
                "0%": {
                  visibility: "hidden",
                  transform: `translateX(${navigationSubmenuDesktopWidth})`,
                },
                "1%": {
                  visibility: "visible",
                },
                to: {
                  visibility: "visible",
                  transform: "translateX(0px)",
                },
              },
              "@keyframes slideOut": ab({
                _: {
                  form: {
                    opacity: 1,
                  },
                  to: {
                    opacity: 0,
                  },
                },
                md: {
                  "0%": {
                    visibility: "visible",
                    transform: "translateX(0px)",
                  },
                  "99%": {
                    visibility: "visible",
                  },
                  "100%": {
                    visibility: "hidden",
                    transform: `translateX(${navigationSubmenuDesktopWidth})`,
                    width: 0,
                  },
                },
              }),
            },
          }}
        >
          <div
            role="button"
            tabIndex="0"
            onKeyPress={this.handleClick}
            onClick={this.handleClick}
            sx={{
              mr: "35px",
            }}
          >
            <span
              sx={{
                variant: this.props.currentPage
                  ? "navigation.currentPage"
                  : "navigation.linkbtmbrd",
              }}
            >
              {this.props.displayName}
            </span>
            <div
              sx={{
                height: 30,
                width: 30,
                float: "right",
                marginTop: "-6px",
                mr: "-35px",
              }}
            >
              <Icon style={{ fill: colors.navigation.icon }} icon="right" />
            </div>
          </div>
          {(this.state.open || this.state.currentPage) && (
            <NavigationSubmenu
              navigationItems={this.props.navigationItems}
              closeFn={this.closeFn}
              open={this.state.open}
              currentPage={this.state.currentPage}
              backFn={this.toggleOpen}
              displayName={this.props.displayName}
              currentLanguage={this.props.currentLanguage}
              seoLinks={this.state.seoLinks}
              url={this.props.url}
              style={{
                left: "0 !important",
                bottom: 0,
                transition: " all 400ms ease-out",
                ...this.props.style,
              }}
            />
          )}
        </div>
      )
    } else if (this.props.url) {
      return (
        <div
          sx={{
            color: "navigationText",
            textAlign: "left",
            fontSize: 2,
            padding: 20,
          }}
        >
          <Link
            to={this.props.url}
            language={this.props.currentLanguage}
            seoLinks={this.state.seoLinks}
            sx={{ color: colors.navigationText, textDecoration: "none" }}
          >
            <div
              sx={{
                mr: "35px",
              }}
            >
              <span
                sx={{
                  variant: this.props.currentPage
                    ? "navigation.currentPage"
                    : "navigation.linkbtmbrd",
                }}
              >
                {this.props.displayName}
              </span>
            </div>
          </Link>
        </div>
      )
    } else {
      return null
    }
  }
}

NavigationSubItem.defaultProps = {
  seoLinks: {},
}

NavigationSubItem.propTypes = {
  navigationItems: PropTypes.array,
  closeFn: PropTypes.func,
  parentOpen: PropTypes.bool,
  currentPage: PropTypes.bool,
  displayName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  accentColor: PropTypes.string,
  currentLanguage: PropTypes.oneOf(["de", "en"]).isRequired,
  style: PropTypes.object,
  seoLinks: PropTypes.object,
}

export default NavigationSubItem
